<mat-dialog-content>
  <div>Please confirm that you have received payment from customer so script can be reviewed by the Doctor.</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
<button mat-flat-button class="mm-bg-pink mm-text-white mm-mr-2" (click)="onNoClick()">No</button>
<button mat-flat-button class="mm-bg-green mm-text-white mm-mt-10" (click)="onYesClick()">Yes</button>
</mat-dialog-actions>